
export const PROJECT_PREFIX = {
  "tcode": '/projects/tcode'
}